import React, { useState, useEffect } from "react"
import Wrapper from "../components/Layout"
import Cookies from "universal-cookie"
import { getLatestData, getRandomPreview } from "../urls"
import axios from "axios"
import MySlider from "../components/MySlider"
import VideoPreview from "../components/VideoPreview"

import "../styles/main.css"
import PosterReview from "../components/PosterPreview"

const cookies = new Cookies();

// markup
const IndexPage = () => {
  const [latestData, setLatestData] = useState([]);
  const [topMovies, setTopMovies] = useState([]);
  const [topAnime, setTopAnime] = useState([]);
  const [topTv, setTopTv] = useState([]);
  const [topSeries, setTopSeries] = useState([]);
  const [randomMovies, setRandomMovies] = useState([]);
  const [randomAnime, setRandomAnime] = useState([]);
  const [randomTv, setRandomTv] = useState([]);
  const [randomSeries, setRandomSeries] = useState([]);
  const [previewOverall, setPreviewOverall] = useState({});

  useEffect(() => {
    axios.post(getRandomPreview, {
      'code': cookies.get("code"),
      'prof_code': cookies.get('prof_code')
    })
    .then(res => setPreviewOverall(res.data.random))
    .catch(err => console.error(err))

    axios.post(getLatestData, {
      'code': cookies.get("code"),
      'prof_code': cookies.get('prof_code')
    })
      .then(res => {

        // Setting Latest Data
        let tempData = [];
        res.data.db.latest.map(cat => {
          cat.map(d => {
            tempData.push(d);
          })
        })
        setLatestData(tempData);

        // Setting Top Rated Data
        setTopMovies(res.data.db.topRated.movie[0]);
        setTopAnime(res.data.db.topRated.anime[0]);
        setTopTv(res.data.db.topRated.tv[0]);
        setTopSeries(res.data.db.topRated.series[0]);

        // Setting Picked for You
        setRandomMovies(res.data.db.random.movie[0]);
        setRandomAnime(res.data.db.random.anime[0]);
        setRandomTv(res.data.db.random.tv[0]);
        setRandomSeries(res.data.db.random.series[0]);
      })
      .catch(err => console.error(err))
  }, []);

  const Latest = () => {
    return <div>
      <MySlider data={latestData} text="Latest Additions" />
    </div>
  }

  const TopMovies = () => {
    return <div>
      <MySlider data={topMovies} text="Top Rated Movies" />
    </div>
  }

  const TopTv = () => {
    return <div>
      <MySlider data={topTv} text="Top Rated TV Dramas in India" />
    </div>
  }

  const TopAnime = () => {
    return <div>
      <MySlider data={topAnime} text="Top Rated Anime" />
    </div>
  }

  const TopSeries = () => {
    return <div>
      <MySlider data={topSeries} text="Top Rated Series" />
    </div>
  }

  const RandomTv = () => {
    return <div>
      <MySlider data={randomTv} text="Indian TV Dramas" />
    </div>
  }

  const RandomSeries = () => {
    return <div>
      <MySlider data={randomSeries} text="Web Series" />
    </div>
  }

  const RandomAnime = () => {
    return <div>
      <MySlider data={randomAnime} text="Anime" />
    </div>
  }

  const RandomMovie = () => {
    return <div>
      <MySlider data={randomMovies} text="Handpicked Movies for You" />
    </div>
  }

  if(typeof window !== "undefined"){
    document.addEventListener('contextmenu', event => event.preventDefault());
  }

  return (
    <main>
      <title>Home - Teserakt</title>
      <Wrapper>
        {previewOverall ? <VideoPreview data={previewOverall} /> : <div className="vid-prev"><span id="loading"></span></div>}
        <div className="below-wrapper">
          <Latest />
          <TopMovies />
          <RandomTv />
          <TopSeries />
          <TopTv />
          <TopAnime />
          <RandomSeries />
          <RandomMovie />
          <RandomAnime />
        </div>
      </Wrapper>
    </main>
  )
}

export default IndexPage
